(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ox-all-products"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ox-all-products]').forEach(section=>{
 if(section.dataset.ready)return;section.dataset.ready='true';
 const track=section.querySelector('[data-ox-track]'),button=section.querySelector('[data-ox-pause]');
 let manual=matchMedia('(prefers-reduced-motion: reduce)').matches,hover=false,focus=false,visible=false;
 const paint=()=>{button.setAttribute('aria-pressed',String(manual));button.textContent=manual?button.dataset.playLabel:button.dataset.pauseLabel};
 paint();button.addEventListener('click',()=>{manual=!manual;paint()});
 track.addEventListener('mouseenter',()=>hover=true);track.addEventListener('mouseleave',()=>hover=false);
 track.addEventListener('focusin',()=>focus=true);track.addEventListener('focusout',()=>focus=false);
 new IntersectionObserver(entries=>visible=entries[0].isIntersecting).observe(section);
 const timer=setInterval(()=>{
  if(!section.isConnected){clearInterval(timer);return}
  if(manual||hover||focus||!visible||document.hidden)return;
  const card=track.querySelector('a'),step=card.getBoundingClientRect().width+20;
  if(track.scrollLeft>=track.scrollWidth-track.clientWidth-3)track.scrollTo({left:0,behavior:'auto'});
  else track.scrollBy({left:step,behavior:'smooth'});
 },3500);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ox-shop-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ox-product-showcase')) {
  customElements.define('ox-product-showcase', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.choices = [...this.querySelectorAll('[data-choice]')];
      this.surface = this.querySelector('.ox-showcase__slides');
      this.track = this.querySelector('.ox-showcase__track');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.index = 0;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous?.addEventListener('click', () => this.select(this.index - 1), options);
      this.next?.addEventListener('click', () => this.select(this.index + 1), options);
      this.choices.forEach((button, index) => button.addEventListener('click', () => this.select(index), options));
      this.surface.addEventListener('dragstart', event => event.preventDefault(), options);
      this.surface.addEventListener('pointerdown', event => {
        if (event.button !== 0 || !event.isPrimary || event.target.closest('.ox-showcase__purchase')) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now(), dragging: false };
      }, options);
      this.surface.addEventListener('pointermove', event => {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (!gesture.dragging && Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) {
          this.gesture = null;
          return;
        }
        if (!gesture.dragging && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          gesture.dragging = true;
          this.surface.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
        }
        if (!gesture.dragging) return;
        this.suppressClickUntil = performance.now() + 500;
        const boundary = (this.index === 0 && dx > 0) || (this.index === this.slides.length - 1 && dx < 0);
        const offset = boundary ? dx * .18 : Math.max(-this.surface.clientWidth, Math.min(this.surface.clientWidth, dx));
        this.track.style.transform = `translate3d(${-this.index * this.surface.clientWidth + offset}px,0,0)`;
      }, options);
      this.surface.addEventListener('pointerup', event => {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        this.gesture = null;
        if (!gesture.dragging) return;
        const dx = event.clientX - gesture.x;
        const speed = Math.abs(dx) / Math.max(1, performance.now() - gesture.time);
        const advance = Math.abs(dx) > this.surface.clientWidth * .18 || (Math.abs(dx) > 24 && speed > .45);
        this.suppressClickUntil = performance.now() + 500;
        this.select(this.index + (advance ? (dx < 0 ? 1 : -1) : 0));
      }, options);
      this.surface.addEventListener('pointercancel', () => {
        this.gesture = null;
        this.select(this.index);
      }, options);
      this.surface.addEventListener('click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { ...options, capture: true });
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.indexOf(event.target.closest('[data-slide]'));
        if (index >= 0) this.select(index);
      }, options);
      this.resize = new ResizeObserver(() => this.select(this.index));
      this.resize.observe(this.surface);
      this.select(0);
    }
    select(index) {
      if (!this.slides.length) return;
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.classList.remove('is-dragging');
      this.track.style.transform = `translate3d(${-this.index * this.surface.clientWidth}px,0,0)`;
      this.slides.forEach((slide, i) => {
        slide.inert = i !== this.index;
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.choices.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}


  } catch(e) { console.error(e); }
})();
})();
